// Coupon list from the `pdp_offers` metaobject (PDP block + offers popup).
// Handles copy-to-clipboard and, when a horizontal slider is present, its progress bar.
if (!customElements.get('pdp-coupons')) {
  customElements.define(
    'pdp-coupons',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (evt) => {
          const btn = evt.target.closest('[data-code]');
          if (!btn || btn.disabled || !btn.dataset.code) return;
          this.copy(btn.dataset.code).then(() => this.showCopied(btn));
        });

        this.slider = this.querySelector('.pdp-coupons__slider');
        this.progress = this.querySelector('.pdp-coupons__progress');
        this.bar = this.querySelector('.pdp-coupons__progress-bar');
        if (this.slider && this.progress && this.bar) {
          const update = () => this.updateProgress();
          this.slider.addEventListener('scroll', update, { passive: true });
          new ResizeObserver(update).observe(this.slider);
        }
      }

      updateProgress() {
        const { scrollWidth, clientWidth } = this.slider;
        const overflow = scrollWidth - clientWidth;
        this.progress.hidden = overflow <= 1;
        if (overflow <= 1) return;
        const ratio = clientWidth / scrollWidth;
        const scrolled = Math.abs(this.slider.scrollLeft) / overflow;
        this.bar.style.width = ratio * 100 + '%';
        this.bar.style.transform = 'translateX(' + scrolled * (1 / ratio - 1) * 100 + '%)';
      }

      copy(code) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(code).catch(() => this.fallbackCopy(code));
        }
        this.fallbackCopy(code);
        return Promise.resolve();
      }

      fallbackCopy(code) {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy');
        } catch (e) {}
        ta.remove();
      }

      showCopied(btn) {
        const item = btn.closest('[data-coupon]');
        const label = item.querySelector('[data-copy-label]');
        item.classList.add('is-copied');
        if (label) label.textContent = btn.dataset.copiedText;
        clearTimeout(item._copyTimer);
        item._copyTimer = setTimeout(() => {
          item.classList.remove('is-copied');
          if (label) label.textContent = btn.dataset.copyText;
        }, 2000);
      }
    }
  );
}
